import React from 'react';
import classnames from 'classnames';

const Layout = ({
    children,
    overrideMedia,
}) => {

    const classes = classnames('b-view authenticated', {
        'is-override-bar-visible': overrideMedia !== '',
    });
    return (
        <div className={classes}>
            {children}
        </div>
    );
};
export default Layout;
